import { PagePaths } from "../../../../types";

export const menuItems = [
  {
    labelKey: "nav.home",
    to: PagePaths.home,
    icon: { variant: "home" as const },
  },
  {
    labelKey: "nav.organization",
    to: PagePaths.organization,
    icon: { variant: "organization" as const },
  },
  {
    labelKey: "nav.subscription",
    to: PagePaths.billing,
    icon: { variant: "dollarSign" as const },
  },
  {
    labelKey: "nav.benefits",
    to: PagePaths.perks,
    icon: { variant: "shieldCheck" as const },
  },
  {
    labelKey: "nav.team",
    to: PagePaths.team,
    icon: { variant: "users" as const },
  },
];
